import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CustomerDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

/**
 * Pipe regarding the displaying of customer names.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see CustomerNamesToStringService
 */
@Pipe({
  name: 'customerNamesToString',
  standalone: true
})
export class CustomerNamesToStringPipe implements PipeTransform {

  public transform(customer: CustomerDto, ...args: unknown[]): string {
    return CustomerNamesToStringService.transform(customer, args);
  }

}

/**
 * Pipe regarding the displaying of customer names.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see CustomerNamesToStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerNamesToStringService {

  public static transform(customer: CustomerDto, ...args: unknown[]): string {
    let nameArray: string[] = [];
    if (customer.customerName != undefined && customer.customerName.length > 0) {
      nameArray.push(customer.customerName);
    }
    if (customer.customerName2 != undefined && customer.customerName2.length > 0) {
      nameArray.push(customer.customerName2);
    }
    if (customer.customerName3 != undefined && customer.customerName3.length > 0) {
      nameArray.push(customer.customerName3);
    }
    let name = nameArray.join(` `).trim();
    return name;
  }

}
